import { render, staticRenderFns } from "./AdvanceStatement.vue?vue&type=template&id=ebb259ec"
import script from "./AdvanceStatement.vue?vue&type=script&lang=js"
export * from "./AdvanceStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports